import { Row, Col } from "react-bootstrap";

const ContactUs = () => {
  const text = (
    <div>
      <p>
        <b>Contact Us</b>
      </p>
      <p>For queries, please contact </p>
      <p>
        Email: <a href="mailto: cor@epa.ie">cor@epa.ie</a>.
      </p>
      <p>Telephone: 043 91 60600.</p>
      <p>
        Further information and guidance in relation to certificates of
        registration is available at&nbsp;
        <a
          style={{ fontWeight: "bold" }}
          href="https://www.epa.ie/our-services/licensing/waste/certs-of-registration/"
        >
          https://www.epa.ie/our-services/licensing/waste/certs-of-registration/.
        </a>
      </p>
    </div>
  );

  return (
    <Row>
      <Col className="ps-4">{text}</Col>
    </Row>
  );
};

export default ContactUs;
